<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-select :items="getCodeDateUtil('accountType')" label="使用者類別" dense clearable class="font-weight-normal" v-model="queryObject.type" @change="getInterpreterFromServer"></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-text-field type="text" label="機關團體名稱" dense clearable class="font-weight-normal" v-model="queryObject.mainDeptName" @input="getInterpreterFromServer"></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="6" md="6" >
          <v-text-field type="text" label="姓名" dense clearable class="font-weight-normal" v-model="queryObject.name" @input="getInterpreterFromServer"></v-text-field>
        </v-col>
  
        <v-col cols="12" xs="12" sm="6" md="6" >
             <v-dialog
            ref="dialog"
            v-model="selectDate"
            :return-value.sync="dates"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dateRangeText"
                @click:clear="dates=[];getInterpreterFromServer();"
                label="申請日期"
                readonly
                v-on="on"
                clearable
                class="font-weight-normal"
              ></v-text-field>
            </template>   
            <v-date-picker
              v-model="dates"
              locale="zh-tw"
              style="font-family:Microsoft JhengHei;"
              color="red"
              scrollable
              range
            >
              <v-spacer></v-spacer>
              <v-btn color="grey lighten-3" style="color:black;" @click="selectDate = false">取消</v-btn>
              <v-btn color="red" style="color:white;"  class="ma-2" @click="$refs.dialog.save(dates);getInterpreterFromServer();" >確定</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="pageSize"
            :loading="loading"
            :footer-props="{ itemsPerPageText:'每頁筆數' }"
            class="elevation-1"
            widths="1500"
            no-data-text="無資料"
            loading-text="資料傳輸中"
            hide-default-footer
            multi-sort
          >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>
              <v-row class="pa-3 ma-5" align="center" justify="center">
                <v-col>
                <span class="red--text">共 {{totalCount}} 筆，每頁筆數</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn dark text color="red" class="ml-2" v-on="on">
                      {{ itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </v-col>
                <!--
                <v-spacer></v-spacer>
                <span class="mr-4 red--text">Page {{ currentPage }} / {{ maxPage }}</span>
                <v-btn small fab dark color="red darken-3" class="mr-1" @click="formerPage">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn small fab dark color="red darken-3" class="ml-1" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>-->
              </v-row>
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" persistent max-width="1024">
      
                <v-card>
                    <v-card-title class="red" dark>
                      <h2>
                        <font style="color:white">審核</font>
                      </h2>
                    </v-card-title>
      
             <v-card-text>
                <v-form ref="form" v-model="valid">
                  <div v-if="member.type === 'AAA' || member.type === 'BBB'">

                    <v-row dense>
                      <v-col cols="12" md="8"></v-col>
                      <v-col cols="12" md="8"><h3>機關團體基本資料</h3></v-col>
                      <v-col cols="12" md="8"></v-col>
                      <v-col cols="12" md="8"></v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" sm="12" md="8">
                        <v-select
                          :items="[{ text: '需求單位', value: 'AAA' },{ text: '培訓單位', value: 'BBB' }]"
                          label="使用者類別"
                          dense
                          v-model="member.type"
                          class="font-weight-normal"
                          disabled
                        ></v-select>
                        <v-checkbox v-model="member.domain" v-if="member.type === 'AAA'" label="是否有開設通譯培訓課程" disabled></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="帳號"
                          type="text"
                          class="font-weight-normal"
                          v-model="member.account"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row dense>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="機關代號或統一編號"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.mainDeptId"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="機關名稱"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.mainDeptName"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          :items="districtArray1"
                          item-text="name"
                          item-value="id"
                          v-model="member.city"
                          label="聯絡縣市"
                          dense
                          class="font-weight-normal"
                          disabled
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          :items="districtArray2"
                          item-text="name"
                          item-value="id"
                          label="聯絡地區"
                          dense
                          class="font-weight-normal"
                          v-model="member.district"
                          disabled
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="聯絡地址"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.contactAddress"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="使用者姓名"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.name"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="職稱"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.titleName"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          id="contactHomeTel"
                          label="聯絡電話"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.contactOfficeTel"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          id="contactOfficeTelExt"
                          label="分機"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.contactOfficeTelExt"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          id="contactMobileTel"
                          label="傳真"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.contactFax"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="電子信箱"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.email"
                          disabled
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-if="member.type === 'CCC'">
                    <v-row dense>
                      <v-col cols="12" md="8"></v-col>
                      <v-col cols="12" md="8"><h2>通譯人員基本資料</h2></v-col>
                      <v-col cols="12" md="8"></v-col>
                      <v-col cols="12" md="8"></v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="姓名"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.name"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-radio-group
                          v-model="member.gender"
                          label="性別"
                          dense
                          class="font-weight-normal"
                          disabled
                        >
                          <v-radio label="男" value="M" dense color="red"></v-radio>
                          <v-radio label="女" value="F" dense color="red"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="統一證號或身分證字號"
                          type="text"
                          dense
                          class="font-weight-normal"
                          v-model="member.idNo"
                          disabled
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-menu
                          v-model="menu1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          disabled
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="member.birthday"
                              label="出生日期"
                              readonly
                              v-on="on"
                              disabled
                              dense
                              class="font-weight-normal"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="member.birthday"
                            @input="menu1 = false"
                            locale="zh-cn"
                            style="font-family:Microsoft JhengHei;"
                            color="red"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-autocomplete
                          v-model="member.nationality"
                          :items="getCodeDateUtil('nation')"
                          label="原屬國籍"
                          dense
                          disabled
                          style="font-family:Microsoft JhengHei;"
                          class="font-weight-normal"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-select
                          v-model="member.educationLevel"
                          :items="getCodeDateUtil('eduLevel')"
                          label="教育程度"
                          dense
                          disabled
                          class="font-weight-normal"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-select
                          v-model="member.currentJob"
                          :items="getCodeDateUtil('jobType')"
                          label="現職"
                          dense
                          disabled
                          class="font-weight-normal"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-radio-group
                          v-model="member.qualificationInTaiwan"
                          label="在臺資格與取得證件"
                          dense
                          disabled
                          class="font-weight-normal"
                        >
                          <v-radio label="持中華民國身分證" value="持中華民國身分證" dense color="red"></v-radio>
                          <v-radio label="持有效之中華民國居留證" value="持有效之中華民國居留證" dense color="red"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          :items="districtArray1"
                          item-text="name"
                          item-value="id"
                          v-model="member.city"
                          @change="districtObjectUtil(member.city);"
                          label="聯絡縣市"
                          dense
                          disabled
                          class="font-weight-normal"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-select
                          :items="districtArray2"
                          item-text="name"
                          item-value="id"
                          label="聯絡地區"
                          dense
                          disabled
                          class="font-weight-normal"
                          v-model="member.district"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="聯絡地址"
                          type="text"
                          dense
                          disabled
                          class="font-weight-normal"
                          v-model="member.contactAddress"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4"></v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          id="contactHomeTel"
                          label="住家電話"
                          type="text"
                          dense
                          disabled
                          class="font-weight-normal"
                          v-model="member.contactHomeTel"
                          @change="checkContactHomeTel"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          id="contactMobileTel"
                          label="行動電話"
                          type="text"
                          dense
                          disabled
                          class="font-weight-normal"
                          v-model="member.contactMobileTel"
                          @change="checkContactMobileTel"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          label="電子信箱"
                          type="text"
                          dense
                          disabled
                          class="font-weight-normal"
                          v-model="member.email"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-textarea
                          label="個人註記及通譯服務經歷"
                          type="text"
                          dense
                          disabled
                          rows="3"
                          class="font-weight-normal"
                          v-model="member.note"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-col cols="12" md="8">
                      <h2>通譯服務資訊</h2>
                    </v-col>
                    <v-row dense>
                      <v-col cols="12" md="8">
                        <v-menu
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="member.serviceStartDate"
                              label="開始從事通譯服務時間"
                              readonly
                              v-on="on"
                              dense
                              disabled
                              class="font-weight-normal"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="member.serviceStartDate"
                            @input="menu2 = false"
                            locale="zh-cn"
                            style="font-family:Microsoft JhengHei;"
                            color="red"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-autocomplete
                          item-color="red"
                          v-model="serviceType"
                          :items="getCodeDateUtil('serveType')"
                          dense
                          chips
                          small-chips
                          label="服務類型(可複選)"
                          multiple
                          disabled
                          class="font-weight-normal"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-autocomplete
                          item-color="red"
                          v-model="serviceLanguage"
                          :items="getCodeDateUtil('lang')"
                          dense
                          chips
                          small-chips
                          label="熟悉語言(可複選)"
                          multiple
                          disabled
                          class="font-weight-normal"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-label class="font-weight-normal">
                          <p class="font-weight-normal">可服務地區 (可複選)</p>
                        </v-label>
                      </v-col>
                  
                      <v-col cols="12" md="10">
                        <div
                          v-show="selectItem.length==0 && areaFlag && !dialogDistrict"
                          class="v-text-field__details"
                        >
                          <div class="v-messages theme--light error--text" role="alert">
                            <div class="v-messages__wrapper">
                              <div class="v-messages__message">
                                <B>此欄位是必填</B>
                              </div>
                            </div>
                          </div>
                        </div>
                        <v-scroll-x-transition group hide-on-leave>
                          <v-chip
                            v-for="(selection, i) in selectItem"
                            :key="i"
                            color="grey"
                            dark
                            small
                            disabled
                            class="ma-1 font-weight-normal"
                          >
                            <v-icon left small @click="selectItem.splice(i,1)">mdi-window-close</v-icon>
                            {{ selection }}
                          </v-chip>
                        </v-scroll-x-transition>
                        <div v-if="dialogDistrict">
                          <v-dialog v-model="dialogDistrict" width="250px">
                            <DistrictComponents
                              :selectItem="selectItem"
                              v-on:childDialog="parentDialog"
                              v-on:update-text="getChildText"
                            ></DistrictComponents>
                          </v-dialog>
                        </div>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-label>
                          <p class="font-weight-normal">
                            <br />可服務時間
                            (可複選)
                          </p>
                          <div
                            v-show="serviceTime.length==0 && serviceTimeFlag "
                            class="v-text-field__details"
                          >
                            <div class="v-messages theme--light error--text" role="alert">
                              <div class="v-messages__wrapper">
                                <div class="v-messages__message">
                                  <B>此欄位是必填</B>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-label>
                      </v-col>
                      <v-col cols="12" md="12" sm="8">
                        <v-simple-table>
                          <thead>
                        <tr>
                        <th class="text-center"></th>
                        <th class="text-center"><v-label>早上 06:00-12:00</v-label></th>
                        <th class="text-center"><v-label>中午 12:00-18:00</v-label></th>
                        <th class="text-center"><v-label>晚上 18:00-24:00</v-label></th>
                        <th class="text-center"><v-label>午夜 00:00-06:00</v-label></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                        <td class="text-center">一</td>
                        <td><v-checkbox v-model="serviceTime" value="a1" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a2" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a3" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="a4" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">二</td>
                        <td><v-checkbox v-model="serviceTime" value="b1" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b2" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b3" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="b4" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">三</td>
                        <td><v-checkbox v-model="serviceTime" value="c1" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c2" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c3" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="c4" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">四</td>
                        <td><v-checkbox v-model="serviceTime" value="d1" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d2" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d3" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="d4" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">五</td>
                        <td><v-checkbox v-model="serviceTime" value="e1" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e2" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e3" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="e4" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">六</td>
                        <td><v-checkbox v-model="serviceTime" value="f1" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f2" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f3" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="f4" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        </tr>
                        <tr>
                        <td class="text-center">日</td>
                        <td><v-checkbox v-model="serviceTime" value="g1" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g2" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g3" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        <td><v-checkbox v-model="serviceTime" value="g4" hide-details color="red" class="align-center justify-center" disabled></v-checkbox></td>
                        </tr>
                      </tbody>
                        </v-simple-table>
                      </v-col>
                    </v-row>
                  </div>
                </v-form>
             
                <br/><br/><br/><br/><br/>       
              </v-card-text>
                  <v-col cols="12"  sm="6" md="4" offset-md="1">
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="member.createDate"
                          label="申請日期"
                          readonly
                          v-on="on"
                          disabled
                          dense
                          class="font-weight-normal"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="member.createDate"
                        @input="menu1 = false"
                        locale="zh-cn"
                        style="font-family:Microsoft JhengHei;"
                        color="red"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" offset-md="1">
                    <v-select multiple :items="getCodeDateUtil('ugrpGroup')" label="權限群組" dense class="font-weight-normal" v-model="ugrpIdArray" :rules="selectRequiredRules" > </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" offset-md="1">
                    <v-select :items="getCodeDateUtil('accountStatus')" label="審核結果" dense class="font-weight-normal" v-model="member.status" ></v-select>
                  </v-col>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                      <v-btn color="grey lighten-3" style="color:black;" @click="canceldata();">取消</v-btn>
                      <v-btn color="red" style="color:white;" @click="savedata" :disabled="(!valid)">儲存</v-btn>
                  </v-card-actions>
                </v-card>   
              </v-dialog>  
            </v-toolbar>
          </template>
            <template v-slot:item.status="{ item }">
              {{getColor(item.status)}}
            </template>
            <template v-slot:item.type="{ item }">
              {{getColor(item.type)}}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                  class="mr-2"
                  @click="editItem(item)"
                >
                  edit
                </v-icon>
  
            </template>

            <template v-slot:footer>
              <div class="text-center pa-2 ma-2">
                <v-pagination 
                  color="red"
                  v-model="currentPage" 
                  :length="maxPage" 
                  :total-visible="9"
                  @input="getInterpreterFromServer()"
                ></v-pagination>
              </div>
            </template>

          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import swal from "sweetalert2";
import DistrictComponents from "../Common/DistrictComponents";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
      DistrictComponents
    // InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
    dateRangeText () {
      //console.log("dates: " + this.isNotBlankUtil(this.dates))
      console.log(" dates: " + this.dates)
      if (this.isNotBlankUtil(this.dates))
      {
        return this.dates.join(' ~ ')
      } else {
        //this.dates= []
        //this.dates.length=0
        return ""
      }
    },
  },
  data() {
    return {
      menu1: false,
      menu2: false,

      ac: null,
      pw: null,
      pw2: null,
      row1: null,
      formHasErrors: false,
      

      typeFlag: true,
      dialogDistrict: false,
      testStr: null,
      districtArray1: this.getCodeDateUtil("district"),
      districtArray2: [],
      city: String,
      registerToken: null,
      serviceTime: [],
      selectItem: [],
      serviceType: [],
      serviceLanguage: [],
      areaFlag: false,
      serviceTimeFlag: false,
      editedIndex: -1,
      member: this.getModel("motorAccount"),
      editedItem: {
        uuid: '',
        name: '',
        email: '',
        password:'',
        type:'',
        status: '',
        dateRange: [],
      },
      defaultItem: {
        type: 'A',
        subject: '',
        postDate: '',
        announContent:'',
        status: 'Y',
        dateRange:[],
      },
       finalObject: [],
      date: new Date().toISOString().substr(0, 10),
      //date: null,
      dates:[],
      ugrpIdArray: [],
      selectDate: false,
      
      date2: new Date().toISOString().substr(0, 10),
      //date: null,
      dates2:[],
      selectDate2: false,
      dialog2: false,

      date3: new Date().toISOString().substr(0, 10),
      menu3: false,

      dialog: false,
      dialogResponeIp: false,
      dialogResponeDept: false,
      dialogRadio: null,
      valid: false,
      firstname: "",
      lastname: "",
      selectRequiredRules: [v => v.length != 0 || "此欄位是必填"],
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 10 || "Name must be less than 10 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      rating: 3.5,
      targetItem: {},
      selectedArray: [],
      selectOption: ["A", "B"],
      desserts: [],
      totalDesserts: 0,
      loading: false,
      options: {},

      items: [],
      queryObject: {},
      queryPager: {
        pageSize: 5,
        currentPage: 1,
        // options: [20, 50, 100],
        // total: 0,
        sortColumnNameList: ["-postDate"]
      },
      itemsPerPageArray: [5,10,30,50],
      currentPage:1,
      itemsPerPage: 5,
      maxPage:0,
      pageSize:10,
      totalCount:0,
      criterion: {},
      headers: [
        { text: "使用者類別", value: "type"   },
        { text: "機關團體名稱", value: "mainDeptName"  },
        { text: "姓名", value: "name"},
        { text: "連絡電話", value: "showTel" },
        { text: "申請日期", value: "createDate" },
        { text: "審核", value: "action", sortable: false }
      ],

    };
  },
  watch: {
    options: {
      handler() {
       this.getInterpreterFromServer()
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    
    parentDialog() {
      this.dialogDistrict = false;
    },
    checkContactHomeTel() {
      let vm = this;
      if (vm.member.contactMobileTel == "") {
        vm.member.contactMobileTel = " ";
        setTimeout(function() {
          vm.member.contactMobileTel = "";
        }, 100);
      }
    },
    checkContactMobileTel() {
      let vm = this;
      if (vm.member.contactHomeTel == "") {
        vm.member.contactHomeTel = " ";
        setTimeout(function() {
          vm.member.contactHomeTel = "";
        }, 100);
      }
    },
    getChildText: function(value) {
      this.selectItem = value;
    },
    getColor(value) {
     if (value == "AAA") {
        return "需求單位";
      }else if (value == "BBB") {
        return "培訓單位";
      }else if (value == "CCC") {
        return "通譯人員";
      }else if (value == "Y") {
        return "啟用";
      }else if (value == "N") {
        return "停用";
      }else if (value == "W") {
        return "待審核";
      }else{
        return value;
      }
    },

    editItem (item) {
      var vm = this;
      this.dates2 = item.dateRange
      this.editedIndex =item.announId
      this.member = Object.assign({}, item)
      this.districtObjectUtil(this.member.city);

      var typeAll = [];
      var languageAll = [];
      var cityAll = [];
      var timeAll = [];
      vm.serviceType = [];
      vm.serviceLanguage = [];
      vm.selectItem = [];
      vm.serviceTime = [];

      if(this.member.serviceType !=null){
        typeAll =  this.member.serviceType.split(",")
        for(let b=0;b<typeAll.length;b++){
              //console.log("typeAll"+typeAll[b]);
                vm.serviceType.push(typeAll[b]);
        }
      }
      if(this.member.serviceLanguage !=null){
        languageAll =  this.member.serviceLanguage.split(",")
        for(let b=0;b<languageAll.length;b++){
              //console.log("languageAll"+languageAll[b]);
                vm.serviceLanguage.push(languageAll[b]);
        }
      }
      if(this.member.serviceCity !=null){
        cityAll =  this.member.serviceCity.split(",")
        for(let b=0;b<cityAll.length;b++){
              //console.log("languageAll"+cityAll[b]);
                vm.selectItem.push(cityAll[b]);
        }
      }
      if(this.member.serviceTime !=null){
        timeAll =  this.member.serviceTime.split(",")
        for(let b=0;b<timeAll.length;b++){
              //console.log("serviceTime"+timeAll[b]);
                vm.serviceTime.push(timeAll[b]);
        }
      }

      this.dialog = true
      vm.ugrpIdArray = [];
      vm.axios
        .get(
          vm.idbServerUrl + "idb/auth/AuthRoleTarget/" +
            item.uuid,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //console.log("response?? " + JSON.stringify(response));
          vm.items2 = response.data.resultList
          for (var i = 0; i < vm.items2.length; i++) {
            //console.log("vm.items.roleId"+vm.items2[i].roleId)
            vm.ugrpIdArray.push(vm.items2[i].roleId);
          }
          //vm.successSwalUtil();
        })
        .catch(function(error) {
          vm.handErrorUtil(error.response.status);
          //console.log("!!!! " + error);
        });
    },
    canceldata () {
      this.dialog = false
      this.dates2 = []
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
      this.getInterpreterFromServer();
    },
    savedata () {
      var vm = this;
      //console.log("vm.ugrpIdArray.length"+vm.ugrpIdArray.length);
      var objTmpUgrpAdd={}
      vm.finalObject=[]
      //console.log("vm.ugrpIdArray.length"+vm.ugrpIdArray.length)
      if (vm.ugrpIdArray != null && vm.ugrpIdArray.length != 0) {
          for (var j = 0; j < vm.ugrpIdArray.length; j++) {
              objTmpUgrpAdd = {
                roleId: vm.ugrpIdArray[j]        
              };
              vm.finalObject.push(objTmpUgrpAdd);
          }
          var data = {authRoleTargetList:vm.finalObject,memberAccount:vm.member};
          //console.log("datatest" + JSON.stringify(data));
          //console.log("action Edit Item" + vm.editedIndex);
          vm.axios
            .put(vm.idbServerUrl + "idb/member/memberAccount", data, {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            })
            .then(function(response) {
              console.log("response " + JSON.stringify(response));
              swal({
                title: "審核成功",
                allowOutsideClick: false,
                confirmButtonText: "確認",
                showConfirmButton: true
              });
              vm.canceldata();
            })
            .catch(function(error) {
              vm.handErrorUtil(error);
              //console.log(error);
            });
      } else {
          swal({
            title: "請務必選擇至少一個權限群組",
            allowOutsideClick: false,
            showConfirmButton: true
          });
      }
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
      this.getInterpreterFromServer();
    },

    getInterpreterFromServer() {
      var vm = this;
      vm.loading = true;
      const { sortBy, sortDesc } = this.options

      var sortColumnNameList = ["-createDate"]
        sortBy.forEach((element, index) => {
          sortColumnNameList[index] = (sortDesc[index] ? "-" : "") + element;
        });

      vm.queryObject.status="W";
      var queryObjectStr = JSON.stringify(vm.queryObject)

      var queryPagerStr = JSON.stringify({
        pageSize: vm.itemsPerPage,
        currentPage: vm.currentPage,
        sortColumnNameList: sortColumnNameList
      });
      var criterionStr = JSON.stringify({})
      if (vm.isNotBlankUtil(vm.dates))
        criterionStr = JSON.stringify({
          between: [
            {
              propertyName: "createDate",
              startDate: vm.dates[0],
              endDate: vm.dates[1]
            }
          ]
        });
      
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/memberAccount?queryString=" +
            encodeURIComponent(queryObjectStr) +
            "&queryPager=" +
            encodeURIComponent(queryPagerStr) +
            "&criterion=" +
            encodeURIComponent(criterionStr),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
          //var dataResponse = JSON.stringify(response.data.resultList)
          //console.log("resultList \n " + JSON.stringify(response.data.resultList))
          vm.currentPage = response.data.currentPage;
          vm.maxPage = response.data.maxPage;
          vm.pageSize = response.data.pageSize;
          vm.totalCount = response.data.totalCount;
          vm.items = response.data.resultList;
        
          //console.log("resultList??" + JSON.stringify(vm.items));
          for (var i = 0; i < vm.items.length; i++) {
            var newDateStr = ""
            if (vm.items[i].type === "AAA" || vm.items[i].type === "BBB") {
              vm.items[i].showTel = vm.items[i].contactOfficeTel;
            } else if (vm.items[i].type === "CCC") {
              vm.items[i].showTel = vm.items[i].contactHomeTel;
              if (vm.items[i].showTel.length === 0)
                vm.items[i].showTel = vm.items[i].contactMobileTel;
            }
            if (vm.items[i].createDate != null) {
              newDateStr = vm.convertJsonDate(
                vm.items[i].createDate,
                ""
              );
              vm.items[i].createDate = newDateStr;
            }
            if (vm.items[i].birthday != null) {
              newDateStr = vm.convertJsonDate(
                vm.items[i].birthday,
                ""
              );
              vm.items[i].birthday = newDateStr;
            }
          }
          vm.loading = false;
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  
  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
  }
};
</script>




